export default function StatCard({ label, value, sub, accent, testid, icon: Icon }) {
  const color = accent || "#00F0FF";
  return (
    <div
      data-testid={testid}
      className="relative border border-white/10 bg-[#121212] p-5 rounded-sm hover:border-white/25 transition-colors group"
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] font-mono uppercase tracking-widest text-[#8E9196]">{label}</div>
        {Icon ? <Icon className="w-4 h-4 text-[#8E9196] group-hover:text-white" strokeWidth={1.5} /> : null}
      </div>
      <div className="mt-3 font-display font-black text-4xl leading-none" style={{ color }}>
        {value}
      </div>
      {sub ? (
        <div className="mt-2 text-xs text-[#8E9196] font-mono uppercase tracking-wider">{sub}</div>
      ) : null}
      <div className="pointer-events-none absolute bottom-0 left-0 h-[1px] w-0 group-hover:w-full transition-all duration-500" style={{ background: color }} />
    </div>
  );
}
